import React from 'react';
import { RealEstateAgent } from '../../utility/types';
import { DisplayList, ListItem } from './DisplayList';
import agent_placeholder from 'images/realtor-placeholder.png';

const fallbackValue = (value: string | null | undefined) =>
  value || 'Unavailable';

const extractAgentDetails = (agent: RealEstateAgent): ListItem[] => [
  {
    name: 'brokerage',
    value: fallbackValue(agent.office_name),
  },
  {
    name: 'website',
    value: fallbackValue(agent.office_website),
  },
  {
    name: 'trec',
    value: fallbackValue(agent.office_mls_id),
  },
  {
    name: 'mls',
    value: fallbackValue(agent.third_party_id),
  },
  {
    name: 'source',
    value: agent.office_mls_source || 'MLS',
  },
];

type RealEstateAgentCardProps = {
  agent?: RealEstateAgent;
};

export const RealEstateAgentCard = ({ agent }: RealEstateAgentCardProps) => {
  if (!agent) return null;

  const items = extractAgentDetails(agent);
  const agentProfilePhoto = agent.profile_image_url ?? agent_placeholder;
  const isOfficePhoto = !!agent.office_image_url;

  return (
    <div className="flex flex-wrap justify-center md:grid md:grid-cols-3 gap-8">
      <div>
        <img
          src={agentProfilePhoto}
          alt="Agent's photo"
          width={250}
          className="max-h-[300px] m-auto"
        />
        <h3 className="font-bold text-lg text-center mb-2">
          {agent.first_name} {agent.last_name}
        </h3>
        <div className="flex font-bold text-sm flex-wrap justify-center">
          <p>{agent.phone_number || agent.office_phone_number}</p>
          <p>{agent.email || agent.office_email}</p>
        </div>
      </div>
      <div className="col-span-2">
        {isOfficePhoto && (
          <img
            src={agent.office_image_url}
            alt={`${agent.office_name} logo`}
            className="justify-self-center max-h-[100px]"
          />
        )}
        <DisplayList title="" items={items} />
      </div>
    </div>
  );
};
